import { z } from "zod";

export const SettingsFormSchema = z.object({
    Name: z.string(),
    Label: z.string(),
    Value: z.string(),
    Backup: z.string(),
    Description: z.string(),
    Type: z.string(),
    Section: z.string(),
});

export function SettingsFormData(data: z.infer<typeof SettingsFormSchema>) {
    const formData = new FormData();
    formData.append('settingName', data.Name);
    formData.append('settingLabel', data.Label);
    formData.append('settingValue', data.Value);
    formData.append('settingBackup', data.Backup);
    formData.append('settingDescription', data.Description);
    formData.append('settingTypeID', data.Type);
    formData.append('settingSection', data.Section);
    return formData;
}